import api from "./api";

export const registerVSUser = async (payload) => {
  const response = await api.post("/api/v1/vs-users/register", payload);
  return response.data;
};

export const loginVSUser = async (payload) => {
  const response = await api.post("/api/v1/vs-users/login", payload);
  return response.data;
};

export const forgotVSUserPassword = async (payload) => {
  const response = await api.post("/api/v1/vs-users/forgot-password", payload);
  return response.data;
};

export const verifyResetOTP = async (payload) => {
  const response = await api.post("/api/v1/vs-users/verify-reset-otp", payload);
  return response.data;
};

export const resetPasswordWithOTP = async (payload) => {
  const response = await api.post("/api/v1/vs-users/reset-password-with-otp", payload);
  return response.data;
};

export default {
  registerVSUser,
  loginVSUser,
  forgotVSUserPassword,
  verifyResetOTP,
  resetPasswordWithOTP,
};
